<template>
  <div class="my_form">
    <el-form :model="form" ref="ruleForm" inline>
      <el-row>
        <el-col :lg="6" :md="24" v-if="getUserInfo.deptName === '办公室'">
          <el-form-item label="部门:" prop="deptList">
            <el-select filterable v-model="form.deptId" placeholder="请选择部门" clearable>
              <el-option
                v-for="item in deptList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :md="24" v-if="getUserInfo.deptName === '办公室'">
          <el-form-item label="姓名:" prop="userId">
            <el-select filterable v-model="form.userId" placeholder="请选择姓名" clearable>
              <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="7" :md="24">
          <el-form-item label="时间:" prop="date">
            <el-date-picker :clearable="false" v-model="form.date" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :md="24" class="action" style="margin-bottom:20px">
          <el-button size="small" type="primary" @click="submitForm" plain>查询</el-button>
          <download-excel
            style="margin-left:20px"
            class="export-excel-wrapper"
            :data="json_data"
            :fields="json_fields"
            type="xls"
            worksheet="My Worksheet"
            name="日常考勤记录"
          >
            <el-button size="small" >导出</el-button>
          </download-excel>
        </el-col>
      </el-row>
    </el-form>
    <div class="record">
      <div class="record-box" v-for="item in list" :key="item.name">
        <div class="title">{{ item.title }}</div>
        <div class="count">{{ item.count }}</div>
      </div>
    </div>

    <PTable :columns="columns" :loadData="loadData" ref="table">
      <template #sn='{ $index }'>
        {{ $index + 1 }}
      </template>
      <template v-for="(item, index) in propArr" :slot="`${item}dutyTime`" slot-scope="scope">
        <div :class="className(scope.row.oaEmployeeDailyAttendList[index],'dutyTime')">
          {{ scope.row.oaEmployeeDailyAttendList[index].realDutyTime }}
        </div>
      </template>
      <template v-for="(item, index) in propArr" :slot="`${item}offTime`" slot-scope="scope">
        <div :class="className(scope.row.oaEmployeeDailyAttendList[index],'offTime')">
          {{ scope.row.oaEmployeeDailyAttendList[index].realOffTime }}
        </div>
      </template>
    </PTable>
  </div>
</template>
  
<script>
import PTable from '@/components/PTable';
import { Attendance } from '@/api/attendance'
import dayjs from 'dayjs'
export default {
  components: {
    PTable,
  },
  data() {
    return {
      // 导出
      json_fields: {},
      json_data: [],
      form: {
        deptName: '',
        userId: '',
        date: [new Date(),new Date()]
      },
      columns: [
        {
          label: '序号',
          scopedSlots: 'sn',
          width: 100,
          fixed:"left"
        },
        {
          label: '基本信息',
          width: 200,
          fixed:"left",
          children: [{
              label: '姓名',
              prop: 'name',
              width: 100
            },
            {
              label: '部门',
              prop: 'deptName',
              width: 130
            }
          ]
        },
        {
          label: '考勤规则',
          width: 230,
          fixed:"left",
          children: [{
              label: '考勤规则',
              prop: 'rule',
              width: 200
            }
          ]
        },
        {
          label: '考勤明细',
          width: 620,
          children: []
        }
      ],
      list: [
        {
          title: '需考勤人数',
          count: 0
        },
        {
          title: '正常(人数)',
          count: 0
        },
        {
          title: '迟到(人数)',
          count: 0
        },
        {
          title: '早退(人数)',
          count: 0
        },
        {
          title: '上班缺卡(人数)',
          count: 0
        },
        {
          title: '下班缺卡(人数)',
          count: 0
        },
        {
          title: '缺勤(人数)',
          count: 0
        },
        {
          title: '请假(人数)',
          count: 0
        }
      ],
      loadData: (pageParam) => {
        const startDate=dayjs(this.form.date[0]).format('YYYY-MM-DD')
        const endDate= dayjs(this.form.date[1]).format('YYYY-MM-DD')
        
        const OaEmployeeDailyAttendControllerQueryList = {
          startDate,
          endDate,
          pageParam,
          userId: this.getUserInfo.deptName === '办公室' ?  this.form.userId : this.getUserInfo.userId,
          deptId:this.form.deptId
        }
        const num = this.getDiffDay(startDate, endDate)
        const arr = []
        const week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
        this.propArr = []
        this.json_fields = {
            '姓名': 'name', //常规字段
            '部门名称': 'deptName', //支持嵌套属性
            '考勤规则':'rule'
        }
        for (let index = 0; index < num; index++){
          const day = dayjs(dayjs(startDate).add(index, 'day')).format('YYYY-MM-DD')
          this.propArr.push(day)
          this.json_fields[`${day}${week[dayjs(day).day()]}(上班)`] = day + 'dutyTime'
          this.json_fields[`${day}${week[dayjs(day).day()]}(下班)`] = day + 'offTime'
          arr.push({
              label: `${day}${week[dayjs(day).day()]}`, 
              prop: day + 'dutyTime',
              scopedSlots: day + 'dutyTime',
              width:90
            },
            {
              label: '', 
              prop: day + 'offTime',
              scopedSlots: day + 'offTime',
              width:90
            }
          )
        }
        this.columns[3].children = arr
        return Attendance.getDayAttendanceList(this, OaEmployeeDailyAttendControllerQueryList).then(res => {
          res.data.dataList.forEach(item => {
            item.rule = '8:30-17:00'
            item.oaEmployeeDailyAttendList.forEach(data => {
              data.realOffTime = data.realOffTime && data.realOffTime.split(' ')[1]
              data.realDutyTime =data.realDutyTime &&  data.realDutyTime.split(' ')[1]
              item[data.date + 'dutyTime'] = data.realDutyTime
              item[data.date + 'isAbsence'] = data.isAbsence 
              item[data.date + 'isAskLeave'] = data.isAskLeave 
              item[data.date + 'isCardReplace'] = data.isCardReplace 
              item[data.date + 'isLackCard'] = data.isLackCard 
              item[data.date + 'isMiss'] = data.isMiss 
              item[data.date + 'isWorkTime'] = data.isWorkTime
              item[data.date + 'isLeaveEarly'] = data.isLeaveEarly
              item[data.date + 'offTime'] = data.realOffTime
            })
          })
          this.json_data = res.data.dataList
          return res
        })
      },
      selectDate: '',
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime()
          if (maxDate) {
            this.selectDate = ''
          }
        },
        disabledDate: (time) => {
         if (this.selectDate !== '') {
            const one = 30 * 24 * 3600 * 1000
            const minTime = this.selectDate - one
            const maxTime = this.selectDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      },
      propArr:[],
      userList: [],
      deptList: []
    }
  },
  created() {
    this.getList()
    this.initData()
  },
  methods: {
    getList() {
      Attendance.gitDict(this, { dictId: '1440944417170001920' }).then(res => {
        this.userList = res.data
      })
      Attendance.gitDict(this, { dictId: '1630757245237071872' }).then(res => {
        this.deptList = res.data
      })
    },
    initData() {
      const data = {
        startDate:dayjs(this.form.date[0]).format('YYYY-MM-DD'),
        endDate: dayjs(this.form.date[1]).format('YYYY-MM-DD'),
        userId:this.form.userId,
        deptId:this.form.deptId
      }
      Attendance.getAttendanceNumber(this,data).then(res => {
          this.list[0].count = res.data.needAttendNum
          this.list[1].count = res.data.normalNum
          this.list[2].count = res.data.lateNum
          this.list[3].count = res.data.earlyNum
          this.list[4].count = res.data.dutyNum
          this.list[5].count = res.data.offNum
          this.list[6].count = res.data.absenceNum
          this.list[7].count = res.data.askNum
      })
    },
    getDiffDay(date_1, date_2) {
      let myDate_1 = Date.parse(date_1)
      let myDate_2 = Date.parse(date_2)
      if (myDate_1 > myDate_2) {
        this.formData.start_time = ''
        this.formData.end_time = ''
        return
      }
      let startDate = new Date(date_1)
      let endDate = new Date(date_2)
      var base = 1000 * 60 * 60 * 24;
      var Days = 0;
      if (endDate.getTime() > 0 && startDate.getTime() > 0) {
        while (endDate.getTime() - startDate.getTime() >= 0) {
            Days++;
          startDate = new Date(startDate.getTime() + base);
        }
        return Days;
      } else {
        return ""
      }
    },
    submitForm() {
      this.initData()
      if (this.$refs.table) this.$refs.table.refresh(true)
    },
    className(data ,type) {
      let name = ''
      // if (data['isLeaveEarly'] && type === 'offTime') {
      //   name = 'red'
      // }
      // if (data['isMiss'] && type === 'dutyTime') {
      //   name = 'red'
      // }
      // if (data['isAbsence'] || data['isAskLeave' ] || data['isCardReplace' ] || data['isLackCard' ] || data['isMiss' ]) {
      //   name = 'red'
      // }
      if(data.attendType !== 'NORMAL'){
        name = 'red'
      }
      if (data['isWorkTime']) {
        name = 'blue'
      }
      return name
     }
  }
}
</script>
  
<style lang="scss" scoped>
.action{
  display: flex;
}
.record {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  margin: 20px 0 40px;

  .record-box {
    border: 1px solid #dedede;
    .title {
      background-color: #f1efef;
      padding: 5px 20px;
    }

    .count {
      text-align: center;
      padding: 15px 0;
    }
  }
}
  .red{
    // background-color: rgb(246, 134, 134);
    color:red;
  }
  .blue{
    // background-color: rgb(161, 161, 245);
    color: blue;
  }
</style>
  